module.exports = __webpack_public_path__ + "static/media/user.801f8414.svg";